import JsonLd from './JsonLd';
import { sitewideSchemas } from '../data/siteSchema';

/** Injects organization / website / professional-service JSON-LD on every route. */
export default function SiteJsonLd() {
  return <JsonLd data={sitewideSchemas} />;
}
